import util from '../util'

let controller = 'MarcacaoFraude'

export default {
  Listar: function (request) {
    return util.Axios.GetAll(controller + '/listar-infracoes', request, true)
  },

  Cancelar: function (data) {
    return util.Axios.Post(controller + '/cancelar', data)
  },
}